"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTerminalNetwork = exports.HOME_NETWORK_NAME = void 0;
const react_1 = require("react");
const types_1 = require("./types");
exports.HOME_NETWORK_NAME = 'home';
function buildSSHCommand(connectedNetworks, setActiveNetwork) {
    return {
        name: 'ssh',
        helpText: 'ssh - Connect to available network - ssh <network name>',
        func: ({ sendToStdout }, args) => __awaiter(this, void 0, void 0, function* () {
            const network = connectedNetworks.find((net) => net.name === args[0]);
            if (!network) {
                sendToStdout({
                    message: `ssh: connect to host ${args[0]} port 22: Connection refused`,
                    type: types_1.TerminalMessageType.Error,
                });
                return;
            }
            yield setActiveNetwork(network.name);
        }),
    };
}
function useTerminalNetwork({ localTerminal, connectedNetworks, }) {
    const homeNetwork = {
        name: exports.HOME_NETWORK_NAME,
        terminalData: localTerminal,
    };
    const homeNetworkRef = (0, react_1.useRef)(homeNetwork);
    homeNetworkRef.current = homeNetwork;
    const connectedNetworksRef = (0, react_1.useRef)(connectedNetworks);
    const [activeNetworkName, setActiveNetworkName] = (0, react_1.useState)(exports.HOME_NETWORK_NAME);
    const getNetworkByName = (networkName) => {
        var _a;
        return (_a = connectedNetworks.find((n) => n.name === networkName)) !== null && _a !== void 0 ? _a : homeNetwork;
    };
    const getNetworkByNameRef = (0, react_1.useRef)(getNetworkByName);
    getNetworkByNameRef.current = getNetworkByName;
    const activeNetwork = (0, react_1.useRef)(homeNetwork);
    activeNetwork.current = getNetworkByName(activeNetworkName);
    const setActiveNetwork = (0, react_1.useCallback)((networkName, skipInitialization = false) => __awaiter(this, void 0, void 0, function* () {
        setActiveNetworkName(networkName);
        const newNetwork = getNetworkByNameRef.current(networkName);
        if (!skipInitialization) {
            yield newNetwork.terminalData.initializeTerminal();
        }
    }), []);
    const logoutCommand = (0, react_1.useMemo)(() => {
        return {
            name: 'logout',
            helpText: 'logout - End terminal session',
            func: () => __awaiter(this, void 0, void 0, function* () {
                const networkName = activeNetwork.current.name;
                yield setActiveNetwork(exports.HOME_NETWORK_NAME, true);
                homeNetworkRef.current.terminalData.sendToStdout(`Connection to ${networkName} closed.`);
            }),
        };
    }, [setActiveNetwork]);
    const initializeNetworkLinks = (0, react_1.useCallback)(() => {
        homeNetworkRef.current.terminalData.setSideloadedCommands(() => {
            return [buildSSHCommand(connectedNetworksRef.current, setActiveNetwork)];
        });
        connectedNetworksRef.current.forEach((network) => {
            network.terminalData.setSideloadedCommands([logoutCommand]);
        });
    }, [setActiveNetwork, logoutCommand]);
    const initialized = (0, react_1.useRef)(0);
    (0, react_1.useEffect)(() => {
        if (initialized.current !== connectedNetworks.length) {
            initialized.current = connectedNetworks.length;
            initializeNetworkLinks();
        }
    }, [initializeNetworkLinks, connectedNetworks]);
    return {
        activeNetwork: activeNetwork.current,
        setActiveNetwork,
        availableNetworks: connectedNetworks,
    };
}
exports.useTerminalNetwork = useTerminalNetwork;
//# sourceMappingURL=useTerminalNetwork.js.map